<template>
  <div>
    <div v-if="showBack" class="robot-header fx">
      <el-button @click="dispatch('robot', 'activeIndexChange', 0)" icon="el-icon-arrow-left" type="text" size="mini">返回</el-button>
    </div>
    <h5 v-if="companyList.length" style="color:#333333;font-size:16px;font-weight: bold;">小T猜你可能对以下企业感兴趣</h5>
    <h5 v-if="companyLoading" style="color:#333333;font-size:16px;font-weight: bold;">小T正在努力查找中...</h5>
    <div v-if="companyLoading" class="loadingBox">
      <i class="el-icon-loading" style="font-size:24px;color:#5088ff" />
    </div>
    <ul class="someCompany">
      <li v-for="company in companyList" :key='company.id'>
        <p @click="preShowDrawer(company)" class="companyName">{{company.name}}</p>
        <p class="tips" :title="company.similarValue">{{company.similarValue}}</p>
      </li>
    </ul>
    <div class="empty" v-show="!companyList.length">
      <div class="empty-ordinary">
        <img src="@/assets/newicons/i002.png" alt="" srcset="">
        <p class="center">暂无数据</p>
      </div>
    </div>
    <div :class="['btns',{'btnsHidden':!companyList.length}]">
      <!-- <div class="allStar btn01" @click="batchStarFn">全部收藏</div> -->
      <!-- <div class="readMore btn02" @click="toPage">查看更多</div> -->
      <el-button type="default-black" w100 @click="batchStarFn">全部收藏</el-button>
      <el-button style="margin-left:20px" type="dialog-confirm" w100 @click="toPage">查看更多</el-button>

    </div>

    <!-- 查看号码抽屉 -->
    <view-number ref="vNumber" :key="drawerKey" :baseData="numberData" :companyStatus="companyStatus" :waiting="loading" @refreshList="contactList" @lookNumber="lookNumberInner"></view-number>
  </div>
</template>

<script>
import viewNumber from '@/components/viewNumber'
import emitter from '@/mixins/emitter'
import { recommendList, batchStar, contactList, contactCount } from '../api/newClueApi'

export default {
  name: 'robotView1',
  components: {
    viewNumber
  },
  mixins: [emitter],
  props: {
    showBack: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      companyList: [],
      numberData: [],
      drawerKey: 0,
      companyStatus: { companyName: '', hid: '', tag: '', contactCount: {} },
      loading: false,
      timmer: null,
      companyLoading: false
    }
  },
  mounted() {
    this.recommendList()
  },
  methods: {
    toPage() {
      if (this.$route.path === '/zxk/junbros/intelRecommend') {
        this.$router.go(0)
      } else {
        this.$router.push({ path: '/zxk/junbros/intelRecommend' })
        // this.$router.push({ path: 'index' })
      }
    },
    batchStarFn() {
      this.batchStar()
    },

    async batchStar() {
      // 同时收藏问题没解决
      const params = this.companyList.map(e => {
        return { name: e.name, hid: e.hid, type: 2, similarValue: e.similarValue, similarity: e.similarity }
      })
      if (params.length) {
        try {
          this.dispatch('robot', 'waitingChange', true)
          // type 2 智能推荐
          const res = await batchStar({ companyList: params })
          this.$message.success('收藏成功')
          this.recommendList()
        } catch (error) {
          this.dispatch('robot', 'waitingChange', false)
        } finally {
        }
      } else {
        this.$message.warning('没有可收藏的了')
      }
      this.dispatch('robot', 'waitingChange', false)
    },

    async recommendList() {
      this.companyList = []
      this.companyLoading = true
      const beforeTime = new Date().getTime()
      const res = await recommendList()
      const nowTime = new Date().getTime()
      const timeOut = 2000 - (nowTime - beforeTime)
      console.log('延时了', timeOut)
      if (res.data?.list.length) {
        this.timmer && clearTimeout(this.timmer)
        if (timeOut > 0) {
          this.timmer = setTimeout(() => {
            this.companyList = res.data.list.filter((e, index) => index < 3)
          }, timeOut)
        } else {
          this.companyList = res.data.list.filter((e, index) => index < 3)
          // this.contactCount()
        }
      } else {
        this.companyList = []
        this.companyLoading = false
      }
    },
    preShowDrawer(company) {
      console.log(company)
      if (this.surplus < 1 && !company.unlock) {
        this.$store.dispatch('PERMISSION_CONFIRM')
        return
      }
      if (window.__sendIframeMessage({ ...company, companyName: company.name })) return
      this.showDrawer(company)
    },

    // 解锁
    async contactList(companyName = this.companyStatus.companyName, hid = this.companyStatus.hid, similarValue) {
      try {
        this.loading = true
        const res = await contactList({ companyName, hid, similarValue, similarity: null })
        this.numberData = res.data.map(e => {
          const count = e.sources.length
          let contactInfo = e.content
          // todo 领取的电话做特殊处理 下期做erp 和正式的兼容
          if (process.env.NODE_ENV == 'erp-prod' && contactInfo && e.isTurnClue) {
            const arr = contactInfo.split('')
            contactInfo = arr.map((e, i) => {
              if (i > 2 && i < 7) {
                return '*'
              }
              return e
            }).join('')
          }
          return { ...e, contactInfo, count: count, contactInfoReal: contactInfo }
        })
        this.$nextTick(() => {
          this.$refs.vNumber.init()
        })
        this.loading = false
      } catch (err) {
        this.loading = false
      }
    },

    showDrawer(company) {
      this.companyStatus = { ...company, companyName: company.name, hid: company.hid, tag: company.regStatus, lockStatus: company.unlock }
      this.contactCount()
      this.$store.commit('closeLastDrawer')
      if (!this.$refs.vNumber.drawer) {
        this.$refs.vNumber.drawerTaggle()
      } else {
        this.drawerKey++
        this.$nextTick(() => {
          this.$refs.vNumber.drawerTaggle()
        })
      }
    },

    async contactCount() {
      try {
        // const { data } = await contactCount([this.companyStatus.companyName])
        const { data } = await contactCount({ hids: [this.companyStatus.hid] })
        this.$set(this.companyStatus, 'contactCount', data[0])
      } catch (e) {

      }
      this.contactList()
    },

    lookNumberInner() {
      this.companyStatus = { ...this.companyStatus, lockStatus: true }
      this.contactCount()
    }
  }
}
</script>

<style lang="scss" scoped>
.robot-header {
  position: absolute;
  top: 6px;
  left: 16px;
  .el-button {
    color: #fff;
  }
}
/deep/ {
  .robot-header {
    .el-button {
      color: #666666;
      display: flex;
      align-items: center;
      font-size: 12px;
      i {
        font-size: 13px;
      }
      span {
        font-size: 12px;
      }
    }
  }
}
h5 {
  text-align: center;
  line-height: 48px;
  font-weight: 400;
  margin-top: 18px;
}
.loadingBox {
  text-align: center;
  > img {
    width: 100%;
  }
}

.someCompany {
  background: rgba(52, 57, 81, 0.05);
  border-radius: 8px;

  li + li {
    border-top: 1px solid rgba(52, 57, 81, 0.05);
  }
  li {
    padding: 20px;
    padding-bottom: 5;
    p {
      line-height: 17px;
    }
    .companyName {
      line-height: 20px;
      margin-bottom: 4px;
      cursor: pointer;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      font-size: 14px;
      font-weight: 600;
      color: #666666;
    }
    .tips {
      font-size: 12px;
      color: #999999;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
}

.btns {
  display: flex;
  justify-content: center;
  padding-top: 24px;
  &.btnsHidden {
    visibility: hidden;
  }
  > div {
    cursor: pointer;
    padding: 10px 20px;
    margin: 10px;
    background-color: #2e313d;
    border-radius: 7px;
    &:hover {
      // color: wheat;
    }
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    line-height: 20px;
  }

  .btn01 {
    background: rgba(255, 255, 255, 0.2);
    box-shadow: 0px 2px 4px 0px #edeef3;
    border-radius: 4px;
    border: 1px solid #bbbeca;
  }
  .btn02 {
    background: #5088ff;
    box-shadow: 0px 6px 10px 0px rgba(80, 136, 255, 0.2);
    border-radius: 4px;
    color: #ffffff;
  }
}
.empty {
  padding: 100px;
  box-sizing: border-box;
  img {
    display: block;
    margin: auto;
    width: 150px;
    margin-bottom: -20px;
  }
  p {
    color: #999999;
    text-align: center;
  }
}
</style>
